export function calculateReadTime(text, wordsPerMinute = 200, imageExtraSeconds = 5) {
    if (!text || typeof text !== "string") return "0 min read";
  
    const words = text.trim().split(/\s+/).length;
    const images = (text.match(/<img/g) || []).length;
  
    const time = Math.ceil(words / wordsPerMinute + images * (imageExtraSeconds / 60));
    return `${time} min read`;
  }
  